import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Layout from "./components/layout";
import './App.css';
import Loading from "./components/loading";

const Subscribe = lazy(() => import("./pages/subscribe"));
const Status = lazy(() => import("./pages/status"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path='/' element={<Layout />}>
            <Route index element={<Subscribe />} />
            <Route path='status' element={<Status />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;